/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';

import { useStore } from 'react-redux';
import { Link } from 'react-router-dom';

// libs
import { Auth } from "lib/firebase";
import configuration from 'config/firebase';

// components
import { MarketSelector } from './market-selector';
import { Burger, NavBarDropdown, NavBarItem } from './nav-bar-views';

// helpers
import { getModulesByRole } from 'controllers/Module';


// reducers
import { clearActiveUser } from 'hyc-store/reducers/user';
import { removeCountry, updateCountry } from 'hyc-store/reducers/countries/countriesReducer';

// import { useSelector } from 'react-redux';
// import { selectCountry } from '../../../redux/reducers/countries/countriesReducer';


const Menus = ({ module }) => {
    if (module.subMenu.length === 1) {
        const menu = module.subMenu[0];
        const label = menu.singleItemName || menu.name;

        return (
            <NavBarItem key={label} path={menu.url} text={label} icon={module.icon} />
        );
    }

    return (
        <NavBarDropdown icon={module.icon} text={module.name}>
            {module.subMenu.map((menu) => (
                <NavBarItem key={menu.name} path={menu.url} text={menu.name} icon={menu.icon} />
            ))}
        </NavBarDropdown>
    );
};

const NavBarMarketSelector = () => {
    const store = useStore();

    const country = localStorage.getItem('country');
    //const country = useSelector(selectCountry);

    const setCountry = (country) => {
        localStorage.setItem('country', country);
        store.dispatch(updateCountry({ value: country }));
        window.location.reload();
    };

    if (window.role !== 'admin') { return null; }

    return <MarketSelector country={country} onChange={setCountry} />
};

const NavigationBar = () => {
    const store = useStore();

    const [modules, setModules] = useState([]);
    const [burgerIsActive, setBurgerIsActive] = useState(false);

    const burgerClass = `navbar-burger ${burgerIsActive ? 'is-active' : ''}`;
    const navBarMenuClass = `navbar-menu ${burgerIsActive ? 'is-active' : ''}`;

    const navBarClass = configuration.projectId === 'hyc-test-777bb' ? 'is-warning' : 'is-light';

    const toggleBurger = () => {
        setBurgerIsActive(!burgerIsActive);
    }

    const logout = () => {
        window.localStorage.removeItem('role');
        window.localStorage.removeItem('country');

        store.dispatch(removeCountry());
        store.dispatch(clearActiveUser());

        Auth.signOut();
    }

    useEffect(() => {
        setModules(getModulesByRole(localStorage.getItem('role')));
    }, []);

    return (
        <nav className={`navbar is-fixed-top ${navBarClass}`} role="navigation" aria-label="main navigation">
            <div className="navbar-brand">
                <Link to="/" className="navbar-item">
                    <img src="/logo.jpeg" className="image" width="35" height="35" alt="HYC Logo" />
                </Link>

                <Burger className={burgerClass} dataTarget="navigation-bar" onClick={toggleBurger} />
            </div>

            <div id="navigation-bar" className={navBarMenuClass}>
                <div className="navbar-start">
                    {modules.map((module) => (
                        <Menus key={module.name} module={module} />
                    ))}
                </div>

                <div className="navbar-end">
                    <NavBarMarketSelector />
                    <div className="navbar-item">
                        <div className="buttons">
                            <a className="button is-light" onClick={logout}>Log Out</a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export { NavigationBar };

